import { memo } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import {
  reactSelectStyles,
  reactSelectTheme,
} from "shared/config/react-select";
import { withPopover } from "shared/lib/hocs/withPopover";
import FormGroup from "../FormGroup/FormGroup";
import { useTranslation } from "react-i18next";
import "./Select.styles.css";

const Select = function Select({
  name,
  register = (name) => ({}),
  setValue = (name, any) => {},
  error = null,
  label = null,
  addon = null,
  control = undefined,
  popoverRef = (el) => ({}),
  displayAs = Form.Group,
  defaultValue = null,
  md = 6,
  shouldUnregister = true,
  popoverHandlers = null,
  readOnly = false,
  ...props
}) {
  const { t } = useTranslation("Shared");
  return (
    <FormGroup
      controlId={name}
      label={label}
      addon={addon}
      error={error}
      displayAs={displayAs}
      md={md}
    >
      <Controller
        name={name}
        shouldUnregister={shouldUnregister}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { ref: formRef, onChange, ...rest } }) => (
          <ReactSelect
            inputId={name}
            ref={(el) => {
              popoverRef(el);
              formRef(el);
            }}
            classNamePrefix="react-select-readonly"
            placeholder={t("placeholders.select")}
            menuPortalTarget={document.body}
            menuPosition={"fixed"}
            onChange={(value) => onChange(value)}
            theme={reactSelectTheme}
            styles={reactSelectStyles}
            className={`w-100 ${error ? "is-invalid border-error" : ""} ${
              readOnly ? "react-select-readonly" : ""
            }`}
            {...popoverHandlers}
            {...rest}
            {...props}
          />
        )}
      />
    </FormGroup>
  );
};

Select.WithPopover = withPopover(Select);
export default memo(Select);
